import styled from "styled-components";

export const OfferCarPrice = styled.p`
    font: normal normal normal 14px/32px Montserrat, serif;
`;
